import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { message, Button } from 'antd';
import localForage from 'localforage';
import MuiButton from 'material-ui/Button';
import MuiIconButton from 'material-ui/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import BizSelect from '../../components/UI/BizSelect';

import BizCard from '../../components/UI/BizCard';
import BizInput from '../../components/UI/BizInput';
import FormFloatingButtons from '../../components/FormFloatingButtons';

import MUTATION from '../../graphql/mutations/mandateCreateMutation.graphql';

// eslint-disable-next-line quotes
const banksNameList = ["State Bank of India", "Allahabad Bank", "Andhra Bank", "Bank of Baroda", "Bank of India", "Bank of Maharashtra", "Canara Bank", "Central Bank of India", "Corporation Bank", "Dena Bank", "Indian Bank", "Indian Overseas Bank", "Oriental Bank of Commerce", "Punjab National Bank", "Syndicate Bank", "Union Bank of India", "United Bank of India", "Punjab & Sind Bank", "UCO Bank", "Vijaya Bank", "IDBI Bank Limited", "Axis Bank Limited", "Bandhan Bank Limited", "Catholic Syrian Bank Limited", "City Union Bank Limited", "DCB Bank Limited", "Dhanlaxmi Bank Limited", "Federal Bank Limited", "HDFC Bank Limited", "ICICI Bank Limited", "IndusInd Bank Limited", "IDFC Bank Limited", "Jammu & Kashmir Bank Limited", "Karnataka Bank Limited", "Karur Vysya Bank Limited", "Kotak Mahindra Bank Limited", "Lakshmi Vilas Bank Limited", "Nainital Bank Limited", "RBL Bank Limited", "South Indian Bank Limited", "Tamilnad Mercantile Bank Limited", "YES Bank Limited", "Au Small Finance Bank Limited", "Capital Small Finance Bank Limited", "FINCARE Small Finance Bank Limited", "Equitas Small Finance Bank Limited", "ESAF Small Finance Bank Limited", "Suryoday Small Finance Bank Limited", "Ujjivan Small Finance Bank Limited", "Utkarsh Small Finance Bank Limited", "North East Small Finance Bank Limited", "Abu Dhabi Commercial Bank PJSC", "American Express Banking Corp.", "AB Bank Limited", "Australia & New Zealand Banking Group Limited", "KEB Hana Bank", "PT Bank Maybank Indonesia TBK", "Bank of America", "Bank of Bahrain and Kuwait B.S.C.", "Bank of Ceylon", "Bank of Nova Scotia", "The Bank of Tokyo - Mitsubishi UFJ", "Limited", "Barclays Bank Plc", "BNP Paribas", "Citibank N.A.", "Credit Agricole Corporate & Investment Bank", "CTBC Bank Co. Limited", "Credit Suisse A.G", "DBS Bank Limited", "Deutsche Bank A.G.", "FirstRand Bank Limited", "Hong Kong and Shanghai Banking Corporation Limited", "Industrial & Commercial Bank of China Limited", "JP Morgan Chase Bank N.A.", "JSC VTB Bank", "Krung Thai Bank Public Co. Limited", "Mizuho Bank Limited", "Mashreqbank PSC", "National Australia Bank", "Industrial Bank of Korea", "Coöperatieve Centrale Raiffeisen-Boerenleenbank B.A.", "Shinhan Bank", "Societe Generale India", "Sonali Bank Limited", "Standard Chartered Bank", "SBM Bank (Mauritius) Limited", "Sberbank", "Sumitomo Mitsui Banking Corporation", "The Royal Bank of Scotland plc.", "United Overseas Bank Limited", "Westpac Banking Corporation", "Woori Bank", "Doha Bank", "First Abu Dhabi Bank PJSC", "Emirates NBD Bank PJSC", "Qatar National Bank SAQ", "Abhyudaya Co-operative Bank Ltd.", "Ahmedabad Mercantile Co-Op Bank Ltd.", "Amanath Co-operative Bank Ltd. Bangalore", "Andhra Pradesh Mahesh Co-Op Urban Bank Ltd.", "Apna Sahakari Bank Ltd.", "Bassein Catholic Co-operative Bank Ltd.", "Bharat Co-operative Bank (Mumbai) Ltd.", "Bharati Sahakari Bank Limited.", "Bombay Mercantile Co-operative Bank Limited", "Citizen Credit Co-operative Bank Ltd.", "Cosmos Co-operative Bank Ltd", "Dombivli Nagari Sahakari Bank Ltd.", "Goa Urban Co-operative Bank Limited.", "Gopinath Patil Parsik Janata Sahakari Bank Ltd.", "Greater Bombay Co-operative Bank Limited", "Indian Mercantile Co-operative Bank Ltd.", "Jalgaon Janata Sahakari Bank Ltd.", "Jalgaon People's Co-operative Bank Ltd.", "Janakalyan Sahakari Bank Ltd.", "Janalaxmi Co-operative Bank Ltd.", "Janata Sahakari Bank Ltd.", "Kallappanna Awade Ichalkaranji Janata Sahakari Bank Ltd.", "Kalupur Commercial Coop.Bank Ltd.", "Kalyan Janata Sahakari Bank Ltd.", "Kapol Co-operative Bank Ltd.", "Karad Urban Co-operative Bank Ltd.", "Mahanagar Co-operative Bank Ltd.", "Mapusa Urban Co-operative Bank of Goa Ltd", "Mehsana Urban Co-Op Bank Ltd.", "Nagar Urban Co-operative Bank Ltd.", "Nagpur Nagrik Sahakari Bank Ltd.", "Nasik Merchant's Co-operative Bank Ltd.", "New India Co-operative Bank Ltd.", "NKGSB Co-operative Bank Ltd.", "Nutan Nagarik Sahakari Bank Ltd.", "Pravara Sahakari Bank Ltd.", "Punjab & Maharashtra Co-operative Bank Ltd.", "Rajarambapu Sahakari Bank Ltd. Rupee Co-operative Bank Ltd.", "Rajkot Nagrik Sahakari Bank Ltd.", "Sangli Urban Co-operative Bank Ltd.", "Saraswat Co-operative Bank Ltd.", "Sardar Bhiladwala Pardi Peoples Coop Bank Ltd.", "Shamrao Vithal Co-operative Bank Ltd.", "Shikshak Sahakari Bank Ltd.", "Solapur Janata Sahakari Bank Ltd.", "Surat Peoples Coop Bank Ltd.", "Thane Bharat Sahakari Bank Ltd", "The Akola Janata Commercial Co-operative Bank Ltd.", "The Akola Urban Co-operative Bank Ltd.", "The Khamgaon Urban Co-operative Bank Ltd.", "TJSB Sahakari Bank", "Vasai Vikas Sahakari Bank Ltd.", "Zoroastrian Co-operative Bank Ltd."];

const DeleteFormRowButton = (props) => (
  <MuiIconButton
    aria-label="Delete"
    onClick={props.onClick}
    style={{ width: 30, height: 30 }}
  >
    <DeleteIcon />
  </MuiIconButton>
);
DeleteFormRowButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const localForageItemkey = (cid) => (`${cid}_mandate`);

const initialState = ({ companyName, fees }) => ({
  startedAt: new Date().toISOString(),
  clientName: companyName,
  dateOfProposal: '',
  clientNameShort: '',
  workScope: 'Arranging & advising for Bank Finance from financial institutions for with following options: \n',
  validity: '',
  fees,
  paymentTerms: [],
  banksList: [],
});


class MandateCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState(props),
    };
  }

  componentDidMount() {
    localForage.getItem(localForageItemkey(this.props.match.params.cid))
      .then((value) => {
        if (value) {
          this.setState({
            ...value,
          });
        }
      });
  }

  clearForm = () => {
    localForage.removeItem(localForageItemkey(this.props.match.params.cid));
    this.setState({
      ...initialState(this.props),
    });
  };

  saveData = () => {
    const { ...data } = this.state;
    localForage.setItem(localForageItemkey(this.props.match.params.cid), data)
      .then(() => {
        message.success('Saved!');
      })
      .catch(() => {
        message.error('Not Saved!');
      });
  };

  handleFormValue = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  handleArrayFormValue = (arrayName, id, key, value) => {
    this.setState({
      [arrayName]: this.state[arrayName].map((entry) => {
        if (entry.id === id) {
          return { ...entry, [key]: value };
        }
        return entry;
      }),
    });
  };

  removeFormRow = (stateObjKey, id) => {
    this.setState({
      [stateObjKey]: this.state[stateObjKey].filter((entry) => (entry.id !== id)),
    });
  };

  createOptionsFromList = (list) => list.map((entry) => ({ label: entry, value: entry }));

  handleFormSubmit = () => {
    const customerId = this.props.match.params.cid;

    this.props.mutate({
      variables: {
        customerId,
        ...this.state,
        paymentTerms: this.state.paymentTerms.map((entry) => (entry.value)),
      },
    })
      .then(() => {
        message.success('Success!');
        this.clearForm();
        this.props.history.push(`/app/lead/${customerId}`);
      })
      .catch((mutateErr) => {
        message.error(mutateErr.message);
      });
  };

  render() {
    const {
      clientName,
      dateOfProposal,
      clientNameShort,
      workScope,
      validity,
      fees,
      paymentTerms,
      banksList,
    } = this.state;

    return (
      <BizCard title="Create Mandate Sheet">
        <FormFloatingButtons handleSave={this.saveData} handleClear={this.clearForm} />
        <table className="biz-form-table">
          <tbody>
            {/* Company Name */}
            <tr>
              <td className="biz-form-table-label">Client Name</td>
              <td className="biz-form-table-input">
                <BizInput name="clientName" theme="lac" onChange={(value) => { this.setState({ clientName: value }); }} value={clientName} />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            {/* Client name shorthand */}
            <tr>
              <td className="biz-form-table-label">Client Name Shorthand</td>
              <td className="biz-form-table-input">
                <BizInput name="clientNameShort" theme="lac" onChange={(value) => { this.setState({ clientNameShort: value }); }} value={clientNameShort} />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            {/* Proposal Date */}
            <tr>
              <td className="biz-form-table-label">Date of Proposal</td>
              <td className="biz-form-table-input">
                <BizInput name="dateOfProposal" theme="lac" onChange={(value) => { this.setState({ dateOfProposal: value }); }} value={dateOfProposal} placeholder="YYYY-MM-DD" />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            {/* Scope of Work */}
            <tr>
              <td className="biz-form-table-label">Scope of Work</td>
              <td className="biz-form-table-input">
                <BizInput
                  name="workScope"
                  theme="lac"
                  onChange={(value) => { this.setState({ workScope: value }); }}
                  value={workScope}
                  type="textarea"
                  textareaRows={5}
                  style={{ width: '100%', height: 200, maxWidth: 'unset' }}
                />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            {/* Validity */}
            <tr>
              <td className="biz-form-table-label">Validity</td>
              <td className="biz-form-table-input">
                <BizInput name="validity" theme="lac" onChange={(value) => { this.setState({ validity: value }); }} value={validity} />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            {/* Fees */}
            <tr>
              <td className="biz-form-table-label">Fees</td>
              <td className="biz-form-table-input">
                <BizInput name="fees" theme="lac" onChange={(value) => { this.setState({ fees: value }); }} value={fees} />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            {/* Payment Terms */}
            <tr>
              <td className="biz-form-table-label">Payment Terms</td>
              <td className="biz-form-table-input">
                {
                  paymentTerms.length > 0 ?
                    <table className="biz-data-table">
                      <thead>
                        <tr>
                          <th>Particulars</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {
                          paymentTerms.map((entry) => (
                            <tr key={entry.id}>
                              <td style={{ minWidth: 400 }}>
                                <BizInput
                                  theme="lac"
                                  name={`paymentTerms[${entry.id}]`}
                                  onChange={(value) => { this.handleArrayFormValue('paymentTerms', entry.id, 'value', value); }}
                                  value={entry.value}
                                  style={{ width: '100%', maxWidth: 'unset' }}
                                />
                              </td>
                              <td>
                                <DeleteFormRowButton onClick={() => { this.removeFormRow('paymentTerms', entry.id); }} />
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    :
                    null
                }
              </td>
              <td className="biz-form-table-action">
                <Button
                  onClick={() => {
                    this.setState({
                      paymentTerms: [...paymentTerms, {
                        id: (+new Date()).toString(36),
                        value: '',
                      }],
                    });
                  }}
                >
                  Add new term
                </Button>
              </td>
            </tr>

            {/* Banks List */}
            <tr>
              <td className="biz-form-table-label">
                The engagement contract will be exclusive for following banks and the service receiver assures not appointing any other advisor nor approaching directly for following banks/ financial institutions
              </td>
              <td className="biz-form-table-input">
                <BizSelect
                  options={this.createOptionsFromList(banksNameList)}
                  theme="lac"
                  onChange={(value) => { this.setState({ banksList: value }); }}
                  name="banksList"
                  value={banksList}
                  multi
                />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            <tr>
              <td className="biz-form-table-label" />
              <td colSpan={2}>
                <MuiButton variant="raised" color="primary" style={{ margin: '5px 0' }} onClick={this.handleFormSubmit}>
                  Submit
                </MuiButton>
              </td>
            </tr>
          </tbody>
        </table>
      </BizCard>
    );
  }
}

MandateCreate.propTypes = {
  companyName: PropTypes.string.isRequired,
  fees: PropTypes.string.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      cid: PropTypes.string.isRequired,
    }),
  }).isRequired,
  mutate: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default graphql(MUTATION)(MandateCreate);



// WEBPACK FOOTER //
// ./src/pages/leads/MandateCreate.jsx